import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./PujaDetails.css";
import ProductBookingModal from "./ProductBookingModal";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { PujaShareMassage, SelectLanguageOptions } from "../../middlewares/Utils";
import Select from "react-select";
import 'react-toastify/dist/ReactToastify.css';
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import share from "../../assets/images/new/share.png";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import LoginPopUp from "../LoginPopup";
import {
  GetPopularPujaAPI,
  GetSlugPujaDataAPI,
} from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import { Helmet } from "react-helmet-async";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID } from "../enum";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import ShareLinkModal from "../ShareLinkModal";

const PoojsDetails = () => {
  const [productBookingModal, setProductBookingModal] = useState(null);
  const [loginPopUp, setLoginPopUp] = useState(null);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { setLoader } = useContext(LoaderContext);
  const { slug } = useParams();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;
  const fromDate = dayjs();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [popularPujaList, setPopularPujaList] = useState([]);
  const [FAQ, setFaq] = useState([]);
  const [pujaPrice, setPujaPrice] = useState(null);
  const [DiscountPrice, setDiscountPrice] = useState(null);
  const [pujaDetailsData, setPujaDetailsData] = useState({
    convenienceFee: null,
    pujaDetails: null,
    pujaDiscount: null,
    pujaId: null,
    pujaImage: null,
    pujaName: null,
    pujaPrice: null,
    pujaSamagri: null,
    pujaSamagriPrice: null,
    CategoryType: null,
    MetaTitle: null,
    MetaDescription: null,
    OpenGraphtag: null,
    CanonicalTag: null,
    ExtraMetaTag: null,
    ShortDescription: null,
    KeyFeature: null,
    PujaSlug: null,
    DrySamagriprice: null,
    WetSamagriPriceTaxAmount: null,
    WetSamagriPrice: null,
    DrySamagriPriceTaxAmount: null,
    DrySamagriPriceTaxPercent: null,
    WetSamagriPriceTaxPercent: null
  });

  const [productBookingData, setProductBookingData] = useState({
    date: null,
    time: null,
    languageID: null,
    landmark: null,
    address: null,
    pincode: null,
    city: null,
    state: null,
    needSamagri: null,
  });
  const pujaStatus = location?.state?.PujaStatus;
  const product = location.state?.product;

  useEffect(() => {
    GetSlugPujaData();
    // GetFAQListByServiceData()
  }, [location]);

  useEffect(() => {
    if (pujaStatus === 1) {
      setPujaPrice(Number(location?.state?.product?.OnlinePujaPrice));
      setDiscountPrice(
        Number(location?.state?.product?.OnlinePujaDiscountAmount)
      );
    } else if (pujaStatus === 2) {
      setPujaPrice(Number(location?.state?.product?.PUJA_PRICE));
      setDiscountPrice(Number(location?.state?.product?.DiscountAmount));
    } else {
      setPujaPrice(null);
      setDiscountPrice(null);
    }
  }, [location]);
  console.log(" ", pujaPrice);
  // useEffect(() => {
  //   // debugger;
  //   setPujaDetailsData((prev) => ({
  //     ...prev,
  //     convenienceFee: location.state.product.CONVENIENCE_FEE,
  //     pujaDetails: location.state.product.PUJA_DETAILS,
  //     pujaDiscount: location.state.product.PUJA_DISC,
  //     pujaId: location.state.product.PUJA_ID,
  //     pujaImage: location.state.product.PUJA_IMAGE,
  //     pujaName: location.state.product.PUJA_NAME,
  //     pujaPrice: location.state.product.PUJA_PRICE,
  //     pujaSamagri: location.state.product.PUJA_SAMAGRI,
  //     pujaSamagriPrice: location.state.product.SAMAGRI_PRICE,
  //     DiscountAmount: location.state.product.DiscountAmount,
  //     CategoryType: location.state.product.CategoryType,
  //   }));
  // }, [location.state]);

  const createMarkup = (html) => {
    return { __html: html };
  };

  const handleOpenProductBookingModal = () => {
    // setProductBookingModal(true);
    // debugger;

    if (isAuthenticated) {
      navigate("/services/book-puja/add-service", {
        state: {
          // product: location.state.product,
          pujaDetailsData: pujaDetailsData,
          PujaPrice: pujaPrice,
          discountAmount: DiscountPrice,
        },
      });
    } else {
      setLoginPopUp(true);
    }
  };

  const HandleProductBookingBtnClicked = () => {
    let isValid = false;

    if (
      productBookingData.date === null ||
      productBookingData.date === undefined ||
      productBookingData.date === "" ||
      productBookingData.time === null ||
      productBookingData.time === undefined ||
      productBookingData.time === "" ||
      productBookingData.landmark === null ||
      productBookingData.landmark === undefined ||
      productBookingData.landmark === "" ||
      productBookingData.languageID === null ||
      productBookingData.languageID === undefined ||
      productBookingData.languageID === "" ||
      productBookingData.address === null ||
      productBookingData.address === undefined ||
      productBookingData.address === "" ||
      productBookingData.state === null ||
      productBookingData.state === undefined ||
      productBookingData.state === "" ||
      productBookingData.city === null ||
      productBookingData.city === undefined ||
      productBookingData.city === "" ||
      productBookingData.pincode === null ||
      productBookingData.pincode === undefined ||
      productBookingData.pincode === "" ||
      productBookingData.needSamagri === null ||
      productBookingData.needSamagri === undefined ||
      productBookingData.needSamagri === ""
    ) {
      isValid = true;
      setError(true);
    }

    // const api_Params = {
    //   date: productBookingData.date,
    //   time: productBookingData.time,
    //   languageID: productBookingData.languageID,
    //   landmark: productBookingData.landmark,
    //   address: productBookingData.address,
    //   pincode: productBookingData.pincode,
    //   city: productBookingData.city,
    //   state: productBookingData.state,
    //   needSamagri: productBookingData.needSamagri,
    // };

    if (!isValid) {
      navigate("/services/book-puja/puja-details/pandit-list", {
        state: { productBookingData: productBookingData, product: product },
      });
    }
  };

  console.log("PujaSlug", pujaDetailsData);

  //   const GetPanditListData = () => {};
  const GetSlugPujaData = async () => {
    // debugger;
    setLoader(true);
    try {
      const response = await GetSlugPujaDataAPI(slug);

      if (response) {
        setLoader(false);
        const modalData = response.DATA[0];
        console.log(modalData, "modalData");
        if (modalData === null || modalData === undefined) {
          navigate("/*");
        }
        setPujaDetailsData((prev) => ({
          ...prev,
          convenienceFee: modalData?.CONVENIENCE_FEE,
          pujaDetails: modalData?.PUJA_DETAILS,
          pujaDiscount: modalData?.PUJA_DISC,
          pujaId: modalData?.PUJA_ID,
          pujaImage: modalData?.PUJA_IMAGE,
          pujaName: modalData?.PUJA_NAME,
          pujaPrice: modalData?.PUJA_PRICE,
          pujaSamagri: modalData?.PUJA_SAMAGRI,
          pujaSamagriPrice: modalData?.SAMAGRI_PRICE,
          DiscountAmount: modalData?.DiscountAmount,
          CategoryType: modalData?.CategoryType,
          SamagriPriceTaxAmount: modalData?.SamagriPriceTaxAmount,
          SamagriPriceTaxPercent: modalData?.SamagriPriceTaxPercent,
          ConvinienceFeeTaxAmount: modalData?.ConvinienceFeeTaxAmount,
          ConvinienceFeeTaxPercent: modalData?.ConvinienceFeeTaxPercent,
          MetaTitle: modalData?.MetaTitle,
          MetaDescription: modalData?.MetaDescription,
          OpenGraphtag: modalData?.OpenGraphtag,
          CanonicalTag: modalData?.CanonicalTag,
          ExtraMetaTag: modalData?.ExtraMetaTag,
          ShortDescription: modalData?.ShortDescription,
          KeyFeature: modalData?.KeyFeature,
          PujaSlug: modalData?.PujaSlug,
          OnlinePujaPrice: modalData?.OnlinePujaPrice,
          PoojaTypeID: modalData?.PoojaTypeID,
          PUJACAT_ID: modalData?.PUJACAT_ID,
          OnlinePujaDiscountAmount: modalData?.OnlinePujaDiscountAmount,
          DrySamagriPriceTaxAmount: modalData?.DrySamagriPriceTaxAmount,
          WetSamagriPriceTaxAmount: modalData?.WetSamagriPriceTaxAmount,
          DrySamagriprice: modalData?.DrySamagriprice,
          WetSamagriPrice: modalData?.WetSamagriPrice,
          DrySamagriPriceTaxPercent: modalData?.DrySamagriPriceTaxPercent,
          WetSamagriPriceTaxPercent: modalData?.WetSamagriPriceTaxPercent,
        }));
        GetMyBookPanditPujaListData(modalData?.PUJACAT_ID, modalData?.PUJA_ID);
        GetFAQListByServiceData(modalData?.PUJA_ID);

        if (pujaStatus === null || pujaStatus === undefined) {
          if (modalData?.PoojaTypeID === 1) {
            setPujaPrice(Number(modalData?.OnlinePujaPrice));
            setDiscountPrice(Number(modalData?.OnlinePujaDiscountAmount));
          } else {
            setPujaPrice(Number(modalData?.PUJA_PRICE));
            setDiscountPrice(Number(modalData?.DiscountAmount));
          }

        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetFAQListByServiceData = async (PujaID) => {
    // debugger;
    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.PujaBooking,
        PujaID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;
        console.log(modalData);
        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const handlePanditCardClick = (data) => {
  //   setShowBookingReviewModal(true);
  // };

  const GetMyBookPanditPujaListData = async (ID, PUJAId) => {
    setLoader(true);
    try {
      const response = await GetPopularPujaAPI(ID || null);
      if (response) {
        setLoader(false);
        const pujaList = response.DATA
        const filteredList = pujaList?.filter((val, index) => val?.PUJA_ID !== PUJAId)
        setPopularPujaList(filteredList);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleToDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setProductBookingData((prev) => ({ ...prev, date: newToDate }));
    } else {
      setProductBookingData((prev) => ({ ...prev, date: null }));
    }
  };

  const handleLanguageChange = (selectedValue) => {
    setProductBookingData((prev) => ({
      ...prev,
      languageID: selectedValue.value,
    }));
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  const FaqObj = [
    {
      question: "What services does Myomnamo offer?",
      answer:
        "Myomnamo offers a range of spiritual services, including Puja and Darshan bookings. You can book experienced Pandits for rituals or arrange daily pujas. Our E-Store provides access to religious goods, and Puja samgari, puja kits. Additionally, Myom namo offers horoscope services.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a temple visit through My OmNamo?",
      answer:
        "Yes, Myomnamo allows you to book temple visits online for your convenience. You can easily select your preferred temple, date, and time through our app. My Om Namo specializes in offering customized puja packages and online Darshans.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, Myomnamo provides a platform to book personalized consultations with experienced spiritual mentors. You can connect with mentors who can offer guidance and support on your spiritual journey. These sessions can provide personalized advice and practices tailored to your specific needs",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  console.log(location.state?.product, "product");
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": pujaDetailsData?.MetaTitle,
    "description": pujaDetailsData?.MetaDescription,
    "image": pujaDetailsData?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": pujaDetailsData?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": pujaDetailsData?.canonicalURL
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pujaDetailsData?.MetaTitle,
    "description": pujaDetailsData?.MetaDescription,
    "url": pujaDetailsData?.canonicalURL,
    "image": pujaDetailsData?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Blog",
        "item": "https://www.myomnamo.com/services/book-puja"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": pujaDetailsData?.MetaTitle,
        "item": pujaDetailsData?.canonicalURL
      }
    ]
  };
  return (
    <>
      <Helmet>
        <title>{pujaDetailsData?.MetaTitle}</title>
        <meta name="description" content={pujaDetailsData?.MetaDescription} />
        <link rel="canonical" href={pujaDetailsData?.CanonicalTag} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={pujaDetailsData?.MetaTitle} />
        <meta
          property="og:description"
          content={pujaDetailsData?.MetaDescription}
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/services/book-puja/${pujaDetailsData?.PujaSlug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MyOmNamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pujaDetailsData?.MetaTitle} />
        <meta
          name="twitter:description"
          content={pujaDetailsData?.MetaDescription}
        />
        <meta name="twitter:image" content="" />
        {pujaDetailsData?.ExtraMetaTag}


        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>

      </Helmet>

      <div className="PujaDetails">
        <div className="PujaDetailsContainer">
          {/* Image and Summary Section */}
          <div className="puja-summary-section">
            {/* Left - Image */}
            <div className="left-puja-details">
              <img
                src={pujaDetailsData.pujaImage || placeholderImg}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = placeholderImg;
                }}
                alt="Puja-Img"
                className="puja-img"
              />
            </div>

            {/* Right - Description & Features */}
            <div className="right description-container">
              <div className="puja-header">
                <div
                  className="d-flex justify-content-end align-items-center gap-4"
                  style={{ width: "100%" }}
                >
                  {/* Share Button */}


                  {/* Proceed Button */}
                  {/* Desktop Button */}

                  <button
                    className="pujacustom-btn Normal-app-btn d-none d-lg-block d-md-block"
                    onClick={handleOpenProductBookingModal}
                  >
                    Proceed to Book
                  </button>


                </div>

                <h1 className="mb-0">{pujaDetailsData.pujaName}</h1>

              </div>



              {/* Pricing Section */}
              <div className="d-flex d-lg-none d-md-none mb-1 justify-content-center">
                <button

                  className="btn btn-block Normal-app-btn w-50"
                  onClick={handleOpenProductBookingModal}
                >
                  Proceed to Book
                </button>
              </div>
              <div className="price-tag position-relative d-inline-block p-2 d-flex  align-items-center">

                <div className="text-dark px-3 py-1 rounded" style={{ background: "#efb423", marginRight: "10px" }}>
                  <strong>
                    ₹{" "}
                    {formatToIndianCurrency(
                      Math.round(pujaPrice - DiscountPrice)
                    )}
                  </strong>

                  {/* <strong>
                ₹{" "}
                {formatToIndianCurrency(
                  product.PUJA_PRICE - product.DiscountAmount
                )}
              </strong> */}
                </div>
                {DiscountPrice !== null &&
                  DiscountPrice !== undefined &&
                  DiscountPrice !== 0 ? (
                  <>
                    <span className="original-price">
                      ₹ {Math.round(pujaPrice)}
                    </span>
                    <span className="discount-text">
                      ({Math.round(Number(pujaDetailsData.pujaDiscount))}% OFF)
                    </span>
                  </>
                ) : (
                  ""
                )}
                <button
                  className=" custom-share-btn"
                  onClick={() => setShowModal(true)}
                  title="Share"
                >
                  <i className="fa-solid fa-up-right-from-square mx-1"></i>
                  Share
                  {/* Share */}
                </button>

              </div>

              {/* Short Description */}
              {pujaDetailsData?.ShortDescription !== null && pujaDetailsData?.ShortDescription !== undefined && (
                <div className="description">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pujaDetailsData?.ShortDescription,
                    }}
                  />
                </div>
              )}


              {/* Samagri / Features */}
              {pujaDetailsData?.KeyFeature !== null &&
                pujaDetailsData?.KeyFeature !== undefined ? (
                <div className="samagri">
                  <h5>Key Features</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pujaDetailsData?.KeyFeature,
                    }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* Description Section */}
          {pujaDetailsData.pujaDetails !== null && pujaDetailsData?.PoojaTypeID !== 1 &&
            pujaDetailsData.pujaDetails !== undefined ? (
            <div className="detailed-description">
              <h5>Description</h5>
              <div
                dangerouslySetInnerHTML={{
                  __html: pujaDetailsData.pujaDetails,
                }}
              />
            </div>
          ) : (
            ""
          )}

          {/* Samagri Section */}
          {pujaDetailsData.pujaSamagri !== null &&
            pujaDetailsData.pujaSamagri !== undefined
            ? pujaDetailsData?.CategoryType !== "Deepdaan" && (
              <div className="detailed-description">
                <h5>Samagri</h5>
                <div
                  dangerouslySetInnerHTML={{
                    __html: pujaDetailsData.pujaSamagri,
                  }}
                />
              </div>
            )
            : ""}

          {/* FAQ Section */}
          {FAQ?.length > 0 && (
            <div className="faq-section">
              <section className="faq-one faq-one--page">
                <div
                  className="container"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="sec-title text-center">
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{
                        perspective: "400px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                      <img className=" tagline-img" src={batuk} alt="" /> FAQs
                      {/* <span className="sec-title__tagline__border"></span> FAQ */}
                    </h6>
                    <h3
                      className="sec-title__title bw-split-in-left"
                      style={{ perspective: "400px", textAlign: "center" }}
                    >
                      Frequently Asked Questions.
                    </h3>
                  </div>
                  <div className="row">
                    <div className="col-xl-2"></div>
                    <div className="col-xl-8">
                      <div className="faq-one__accordion careox-accordion">
                        {FAQ?.map((faq, index) => (
                          <div
                            key={index}
                            className={`accrodion ${activeIndex === index ? "active" : ""
                              }`}
                            style={{ "--accent-color": faq.color }}
                          >
                            <div
                              className="accrodion-title"
                              onClick={() => toggleFAQ(index)}
                            >
                              <h4>
                                <span
                                  className="accrodion-title__number"
                                  style={{
                                    marginRight: "10px",
                                    fontWeight: "500",
                                  }}
                                ></span>
                                {faq.QUESTION}
                                <span className="accrodion-title__icon"></span>
                              </h4>
                            </div>
                            <div
                              className="accrodion-content"
                              style={{
                                maxHeight:
                                  activeIndex === index ? "200px" : "0",
                                overflow: "hidden",
                                transition: "max-height 0.5s ease-in-out",
                              }}
                            >
                              <div className="inner">
                                <p>{faq.ANSWER}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-xl-2"></div>
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* Popular pujas */}
          {popularPujaList?.length > 0 && (
            <>
              <div
                className="sec-title text-center"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <h6
                  className="sec-title__tagline bw-split-in-right"
                  style={{
                    perspective: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                  <img className=" tagline-img" src={batuk} alt="" /> Popular
                  Pujas
                  {/* <span className="sec-title__tagline__border"></span> FAQ */}
                </h6>

                <h6
                  className=" bw-split-in-right"
                  style={{ width: "50vw", marginTop: "20px" }}
                >
                  Explore our most booked pujas! Find peace and prosperity with
                  these powerful ceremonies chosen by devotees like you. Book
                  now!
                </h6>
              </div>
              <div
                className="col-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "25px",
                }}
              >
                {popularPujaList?.slice(0, 4).map((item, index) => (
                  <Link
                    to={`/services/book-puja/${item?.PujaSlug}`}
                    state={{ product: item }}
                  >
                    <div
                      key={index}
                      className="col-lg-3 col-md-6 col-sm-6 product-item-one"
                      style={{
                        marginBottom: "15px",
                        width: "12em",
                        height: "340px",
                      }}
                    >
                      <div
                        className="card card-shadow-sty shadow-sm bg-white rounded p-2 w-100 d-flex h-100"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="product-image text-center position-relative">
                          <img
                            src={item?.PUJA_IMAGE || placeholderImg}
                            className="img-fluid rounded w-100"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = placeholderImg;
                            }}
                            style={{
                              objectFit: "contain",
                              height: "180px",
                            }}
                          />
                        </div>
                        <div
                          className="product-details text-center d-flex align-item-center justify-content-center flex-column flex-grow-1 p-2"
                          style={{ margin: "0" }}
                        >
                          <h6
                            style={{
                              fontSize: "18px",
                              color: "#8f3246",
                              fontWeight: "600",
                            }}
                          >
                            {item.PUJA_NAME}
                          </h6>
                          <div className="prod-details d-flex align-items-center flex-column">
                            <span
                              style={{
                                fontSize: "16px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              ₹ {item.PUJA_PRICE}
                            </span>
                            <span
                              style={{
                                whiteSpace: "nowrap",
                                color: "#a52444",
                                fontSize: "15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                              }}
                            >
                              View Details <i className="icon-right-arrow"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>



        <ProductBookingModal
          show={productBookingModal}
          onHide={() => setProductBookingModal(false)}
          product={pujaDetailsData}
        />
        {loginPopUp && (
          <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
        )}
        <ShareLinkModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          shareUrl={currentUrl}
          message={PujaShareMassage} // Optional
          title="Spread the word" // Optional
        />
      </div>
    </>
  );
};

export default PoojsDetails;
